import React from "react";
import { Icon } from "antd";
import NumberFormat from "../../../../NumberFormat";

/* change_campaign_type — cambio entre programática y tradicional (recalcula presupuesto). */
export default function CampaignTypeProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalType")}</p>
      <div className="chatbot-proposal-change-row">
        <span>{payload.current_type}</span>
        <Icon type="arrow-right" />
        <span className="chatbot-proposal-new-value">{payload.new_type}</span>
      </div>
      <div className="chatbot-proposal-change-row">
        <span>
          {payload.current_budget != null ? (
            <NumberFormat
              value={payload.current_budget}
              currency={payload.currency}
            />
          ) : ""}
        </span>
        <Icon type="arrow-right" />
        <span className="chatbot-proposal-new-value">
          {payload.new_budget != null ? (
            <NumberFormat
              value={payload.new_budget}
              currency={payload.currency}
            />
          ) : ""}
        </span>
      </div>
    </div>
  );
}
